import React, { useState } from "react";
import Button from "components/Button";
import styles from "./CreditPurchaseView.module.scss";

interface CreditPurchaseViewProps {
  onPurchase: (amount: number) => void;
  isProcessing: boolean;
}

const CreditPurchaseView: React.FC<CreditPurchaseViewProps> = ({
  onPurchase,
  isProcessing,
}) => {
  const [quantity, setQuantity] = useState<string>("");

  const handlePurchase = () => {
    const quantityNum = parseInt(quantity);
    if (quantityNum > 0) {
      onPurchase(quantityNum);
    }
  };

  const isDisabled = !quantity || parseInt(quantity) <= 0 || isProcessing;

  return (
    <div className={styles.container}>
      <div className={styles.purchaseForm}>
        <div className={styles.formContent}>
          <div className={styles.inputGroup}>
            <label>Credits to Purchase</label>
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              min="1"
              disabled={isProcessing}
            />
          </div>

          <div className={styles.inputGroup}>
            <label>Payment Method</label>
            <select disabled={true}>
              <option value="stripe">Stripe</option>
            </select>
          </div>
        </div>
        <div className={styles.bottomSection}>
          <div className={styles.total}>
            <span>Total</span>
            <span>SGD {quantity ? parseInt(quantity) : 0}</span>
          </div>
          <Button
            className={styles.purchaseButton}
            text={isProcessing ? "Processing..." : "Purchase"}
            onClick={handlePurchase}
            disabled={isDisabled}
          />
        </div>
      </div>
    </div>
  );
};

export default CreditPurchaseView;
